export default __webpack_public_path__ + "static/media/HackerRankLogo.04e752be.png";